/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExportPeopleConfigurationRequest } from '../models/ExportPeopleConfigurationRequest';
import type { ExportPeopleConfigurationResource } from '../models/ExportPeopleConfigurationResource';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class PeopleExportService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Fetch all ExportPeopleConfiguration records
     * @returns any OK
     * @throws ApiError
     */
    public getExportPeopleConfigurations(): CancelablePromise<{
        data: Array<ExportPeopleConfigurationResource>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/people/export-config',
            errors: {
                400: `Unauthorized`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
            },
        });
    }

    /**
     * Store a new ExportPeopleConfiguration record.
     * This method creates a new configuration for the authenticated user and organization.
     * @returns any Created
     * @throws ApiError
     */
    public createExportExcelConfig({
        requestBody,
    }: {
        /**
         * Export excel config resource to create.
         */
        requestBody: ExportPeopleConfigurationRequest,
    }): CancelablePromise<{
        data: ExportPeopleConfigurationResource;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/people/export-config',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
            },
        });
    }

    /**
     * Delete an ExportPeopleConfiguration record.
     * This method deletes the specified configuration from the database.
     * @returns void
     * @throws ApiError
     */
    public deleteExportPeopleConfiguration({
        id,
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/people/export-config/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`,
            },
        });
    }

}
